import img1 from "../../../assets/img/brands/etg.png"
import img2 from "../../../assets/img/brands/oemff.png"
import img3 from "../../../assets/img/brands/kynoch.png"
import img4 from "../../../assets/img/brands/falcon.png"
export const BrandImg = [
    { url: img1 },
    { url: img2 },
    { url: img3 },
    { url: img4 },
]